import "./styles.css";
import CovidTracker from "./tracker/tracker";
import GlobalData from "./tracker/globaldata";
import IndiaData from "./tracker/indiadata";
import UsaData from "./tracker/usadata";
import VacStatedata from "./tracker/vacStatedata";
import ErrorPage from "./tracker/error";
import VaccineDataIN from "./tracker/vaccine";
import Home from "./home";
import { BrowserRouter, Switch, Route, Link } from "react-router-dom";

function App(props) {
  return (
    <BrowserRouter>
      <div className="App">
        <Switch>
          <Route path="/" exact>
            <Home />
          </Route>
          <Route path="/globaldashboard" exact>
            <CovidTracker apptitle="Global Covid Data Tracker" />
          </Route>
          <Route path="/tracker" exact>
            <CovidTracker apptitle="Global Covid Data Tracker" />
          </Route>
          <Route path="/globalData" exact>
            <GlobalData apptitle="Global Covid Data Tracker" />
          </Route>
          <Route path="/indiadata" exact>
            <IndiaData apptitle="Global Covid Data Tracker" />
          </Route>
          <Route path="/usadata" exact>
            <UsaData apptitle="Global Covid Data Tracker" />
          </Route>
          <Route path="/vacStatedata" exact>
            <VacStatedata apptitle="Global Covid Data Tracker" />
          </Route>
          <Route path="/error" exact>
            <ErrorPage />
          </Route>
          <Route path="/vaccineIN" exact>
            <VaccineDataIN apptitle="Global Covid Data Tracker" />
          </Route>
        </Switch>
      </div>
    </BrowserRouter>
  );
}

export default App;
